<app-inicio-banner></app-inicio-banner>
<app-inicio-rastreo></app-inicio-rastreo>
<app-inicio-beneficios></app-inicio-beneficios>
<app-inicio-servicios [limite]="4"></app-inicio-servicios>
<app-inicio-cobertura></app-inicio-cobertura>
<app-inicio-contacto></app-inicio-contacto>

